/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_LatvianInputs */

const en_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latvian`)
};

const fr_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letton`)
};

const de_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lettisch`)
};

const it_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lettone`)
};

const ru_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`латышский`)
};

const es_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letón`)
};

const zh_cn2_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拉脱维亚语`)
};

const ja_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラトビア語`)
};

const hi_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लात्वीयावासी`)
};

const pt_pt2_speechmatics_target_language_latvian = /** @type {(inputs: Speechmatics_Target_Language_LatvianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letão`)
};

/**
* | output |
* | --- |
* | "Latvian" |
*
* @param {Speechmatics_Target_Language_LatvianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_latvian = /** @type {((inputs?: Speechmatics_Target_Language_LatvianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_LatvianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_latvian(inputs)
	if (locale === "de") return de_speechmatics_target_language_latvian(inputs)
	if (locale === "it") return it_speechmatics_target_language_latvian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_latvian(inputs)
	if (locale === "es") return es_speechmatics_target_language_latvian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_latvian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_latvian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_latvian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_latvian(inputs)
	return en_speechmatics_target_language_latvian(inputs)
});